import axios from 'axios'
// import { MessageBox, Message } from 'element-ui'
import { Toast } from 'vant'
if (process.env.NODE_ENV === "production") {
  localStorage.setItem('apiUrl', 'http://139.224.119.168/')
}else {
  localStorage.setItem('apiUrl', 'http://192.168.2.3/')
  // localStorage.setItem('apiUrl', 'http://139.224.119.168/')
}
// localStorage.setItem('apiUrl', 'http://192.168.2.3/')

// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  baseURL: '', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache'
  },
  loading: true,
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.url = localStorage.getItem('apiUrl') + config.url
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.code == 200) {
      return response.data
    } else {
      Toast.fail('稍后重试或联系工作人员')
      return
    }
  },
  (error) => {
    // 处理请求错误，例如网络问题
    return Promise.reject(error)
  }
);

export default service
